<template>
  <section>
    <section-header
      @toggle="showSection = !showSection"
      @showSort="showSortModal = true"
      :showSection="showSection"
      :section="section"
      :showSort="true"
      :showAdd="true">
      <slot></slot>
    </section-header>

    <div class="content" v-show="showSection && items.length > 0">
      <note class="item-row"
        v-for="item in items"
        :item="item"
        :section="section"
        :key="item._id">
      </note>
    </div>

    <ez-modal v-if="showSortModal" @close="showSortModal = false" size="m-tiny">
      <h3>Notes</h3>
      <sortable :section="section" :items="items"></sortable>
    </ez-modal>
  </section>
</template>
<script>
import { mapState } from "vuex";
import modal from "@/mixins/vue-ez-modal";
import Note from "./_Note.vue";
import SectionHeader from "../shared/_SectionHeader.vue";
import Sortable from "../shared/_Sortable.vue";

export default {
  name: "sheet-notes-index",
  mixins: [modal],
  components: {
    Note,
    SectionHeader,
    Sortable
  },
  data() {
    return {
      section: "notes",
      showSection: true,
      showSortModal: false
    };
  },
  computed: {
    ...mapState({
      items: state => state.characters.current.notes
    })
  }
};
</script>
